/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable max-len */
import { Box, Drawer, Grid, Grow, Stack, Typography } from '@mui/material';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';

// import Playlistimg from '../../../../assets/Resources/playlistimg.svg';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import ProfilePic from '../../../../../components/Common/ProfilePic';
import { LanguageContext } from '../../../../../libs/Context';
import ShareDialog from '../../../../../UiComponents/ShareScreen/ShareDialogPopup';
import { trackArticleView } from '../../../../actions/article_management';
import { trackDocumentView } from '../../../../actions/document_management';
import { trackImageView } from '../../../../actions/image_management';
import { trackPlaylistView } from '../../../../actions/playlist_management';
import { updatePodcastEngagement } from '../../../../actions/podcast_management';
import { trackVideoView } from '../../../../actions/video_management';
import CategorySlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/CategorySlider';
import DocumentDetailsSlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Document/components/DocumentDetailsSlider';
import ImageDetailsSlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Image/components/ImageDetailsSlider';
import PodcastDetailsSlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Podcast/components/PodcastDetailsSlider';
import VideoDetailsSlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Video/components/VideoDetailsSlider';
import { useVideoState } from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Video/hooks/useVideoState';
import { handleMultipleVideoUpdates } from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Creation/Video/VideoUploadHelper';
import useResourceHelper from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Reusable/ContentCards/useResourceHelper';
import DetailsOptionSlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Reusable/RightBarOptions/Components/SliderContent';
import { EditContent } from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/CategoriesView/Components/EditContent';
import MoveToSlider from '../../../../BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/StatusContentSection/CategoriesView/Components/MoveToSlider';
import { CONTENT_SECTIONS, CONTENT_STATUS, CONTENT_TYPES } from '../../../constants';
import { ContentCardProps } from '../../../types';
import { handleContentUpdate, updateLocalContentData as updateContentData } from '../../ContentUpdateHelpers/contentUpdateHelper';
import { transformDocumentDataForSlider, transformImageDataForSlider, transformPodcastDataForSlider, transformVideoDataForSlider } from '../../DataTransformers';
import './ContentCard.css';
import ThumbnailView from './ThumbnailView';
import { toast } from 'react-toastify';

/**
 * ContentCards component for displaying various types of content in card format
 * @param props ContentCardProps containing the card data and display options
 */
const ContentCards = (props: ContentCardProps) =>
{
	const {
		contentData,
		type,
		card,
		icon,
		categories,
		showPath,
		handleCheckboxChange,
		hoveredCardId,
		isChecked,
		section,
		GridView,
		handleClick,
		watermarkTxt,
		subtype,
		disableInteractions,
		from
		// width,
		// user,
		// description,
		// ContentView,
		// shouldShowPopover = true,
		// setContentView,
	} = props;

	const { isAdminView } = useResourceHelper();
	const showPopover = isAdminView;
	const uncategorizedId = useSelector((state:any) => state.myresource?.uncategorizedId) || '';

	// Create a wrapper function for handleMultipleVideoUpdates that matches onSave expected signature
	const handleVideoUpdates = (updatedData: any, videoIds?: any): void =>
	{
		if (videoIds && videoIds.length > 0)
		{
			// Get the companyId from somewhere or use a default
			const companyId = contentData?.companyId || '';

			handleMultipleVideoUpdates(companyId, videoIds, updatedData, contentData);
		}
	};

	// Create variables from contentData object if available
	const _id = contentData?._id;
	const files = contentData?.files;

	let fileUrl;

	if (type === CONTENT_TYPES.IMAGES)
	{
		fileUrl = contentData?.url || contentData?.files?.[0]?.url || contentData?.thumbnail;
	}

	const fileTitle = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.title ?? contentData?.title;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.title ?? contentData?.title;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.title;
			case CONTENT_TYPES.PLAYLISTS:
				return contentData?.name;
			default:
				return contentData?.files?.[0]?.title ?? contentData?.title;
		}
	})();

	const fileDescription = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.description;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.description;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.seasons?.[0]?.description || contentData?.episodes?.[0]?.description;
			case CONTENT_TYPES.PLAYLISTS:
				return contentData?.description;
			default:
				return contentData?.files?.[0]?.description || '';
		}
	})();

	const categoryIds = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.categoryIds;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.categoryIds || contentData?.videos?.[0]?.categoryIds || contentData?.files?.[0]?.categoryIds;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.categoryIds || contentData?.files?.[0]?.categoryIds;
			default:
				return contentData?.files?.[0]?.categoryIds;
		}
	})();

	// For podcasts, get the total number of episodes across all seasons
	const totalEpisodes = type === CONTENT_TYPES.PODCASTS
		? contentData?.seasons?.reduce((total, season) => total + (season?.episodes?.length || 0), 0) || 0
		: undefined;

	// For podcasts, get the total duration across all episodes
	const totalDuration = type === CONTENT_TYPES.PODCASTS
		? contentData?.seasons?.reduce((total, season) =>
			total + (season?.episodes?.reduce((epTotal, ep) => epTotal + (ep?.duration || 0), 0) || 0), 0) || 0
		: type === CONTENT_TYPES.VIDEOS
			? contentData?.videos?.[0]?.duration || contentData?.files?.[0]?.duration
			: undefined;

	const createdBy = contentData?.createdBy;
	const createdByName = contentData?.createdBy?.name;
	const createdAt = contentData?.createdAt;
	const updatedAt = contentData?.updatedAt;

	const fileSize = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.fileSize;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.fileSize || contentData?.files?.[0]?.fileSize;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.seasons?.[0]?.episodes?.[0]?.fileSize;
			default:
				return contentData?.files?.[0]?.fileSize;
		}
	})();

	const dimensions = type === CONTENT_TYPES.IMAGES
		? contentData?.files?.[0]?.dimensions
		: undefined;

	const visibility = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.visibility;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.visibility || contentData?.files?.[0]?.visibility;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.visibility || contentData?.files?.[0]?.visibility;
			default:
				return contentData?.files?.[0]?.visibility;
		}
	})();

	const allowDownload = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.allowDownload;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.allowDownload || contentData?.files?.[0]?.allowDownload;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.allowDownload || contentData?.files?.[0]?.allowDownload;
			default:
				return contentData?.files?.[0]?.allowDownload;
		}
	})();

	const allowShare = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.allowShare;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.allowShare || contentData?.files?.[0]?.allowShare;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.allowShare || contentData?.files?.[0]?.allowShare;
			default:
				return contentData?.files?.[0]?.allowShare;
		}
	})();

	const accessControl = (() =>
	{
		switch (type)
		{
			case CONTENT_TYPES.IMAGES:
				return contentData?.files?.[0]?.accessControl;
			case CONTENT_TYPES.VIDEOS:
				return contentData?.videos?.[0]?.accessControl || contentData?.files?.[0]?.accessControl;
			case CONTENT_TYPES.PODCASTS:
				return contentData?.accessControl || contentData?.files?.[0]?.accessControl;
			default:
				return contentData?.files?.[0]?.accessControl;
		}
	})();

	const {
		state,
		updateModal,
		updateData
	} = useVideoState();
	const { language } = useContext(LanguageContext);
	const [ moveTo, setMoveTo ] = useState<boolean>(false);
	const [ addPlaylist, setAddPlaylist ] = useState<boolean>(false);
	const [ editContent, setEditContent ] = useState<any>(null);
	// const [ anchorElShare, setAnchorElShare ] = useState<HTMLElement | null>(null);
	// const openShare = Boolean(anchorElShare);

	// Get current location to check route path
	const routeLocation = useLocation();
	const navigate = useNavigate();
	const params = useParams();
	const categoryId = useMemo(() =>
	{
		return contentData?.categoryIds?.[0] ?? contentData?.files?.[0]?.categoryIds?.[0];
	}, [ contentData ]);

	// Add local content data state for display updates
	const [ localContentData, setLocalContentData ] = useState(contentData);

	// Sync localContentData with contentData prop changes
	useEffect(() =>
	{
		setLocalContentData(contentData);
	}, [ contentData ]);

	// Get categoryData from router state
	const categoryData = routeLocation.state?.categoryData;

	// State for resolved source category ID (for async lookup) - REMOVED: Now handled in MoveToSlider
	// const [ resolvedSourceCategoryId, setResolvedSourceCategoryId ] = useState<string | null>(null);
	// const [ isLookingUpSourceCategory, setIsLookingUpSourceCategory ] = useState(false);

	// Async source category lookup effect - REMOVED: Now handled in MoveToSlider
	// useEffect(() => {
	// 	... source category lookup logic moved to MoveToSlider
	// }, [ type, localContentData?._id, categoryData, params.categoryId ]);

	// Function to update local content data with changes from slider
	const updateLocalContentData = (updatedData: any) =>
	{
		const updatedContentData = updateContentData(localContentData, updatedData, type);

		setLocalContentData(updatedContentData);
	};

	// Create a wrapper function for handleMultipleVideoUpdates that matches onSave expected signature
	const handleContentUpdates = async (updatedData: any, contentIds?: any): Promise<void> =>
	{
		if (!contentIds || contentIds.length === 0) return;

		try
		{
			await handleContentUpdate(
				updatedData,
				contentIds,
				contentData,
				type,
				updateLocalContentData,
				() => setEditContent(null)
			);
		}
		catch (error)
		{
			console.error('Content update failed:', error);
		}
	};

	const getContentStatus = () =>
	{
		let status;

		switch (type)
		{
			case CONTENT_TYPES.VIDEOS:
				status = contentData?.videos?.[0]?.status;
				break;
			case CONTENT_TYPES.IMAGES:
			case CONTENT_TYPES.DOCUMENTS:
				status = contentData?.files?.[0]?.status;
				break;
			case CONTENT_TYPES.PLAYLISTS:
				status = contentData?.enabled ? 'enabled' : 'disabled';
				break;
			case CONTENT_TYPES.PODCASTS:
				status = contentData?.status;
				break;
			case CONTENT_TYPES.ARTICLES:
				status = contentData?.status;
				break;

			default:
				status = undefined;
		}

		return status?.toLowerCase();
	};

	const contentStatus = getContentStatus();

	// Keep existing status checks
	const isPublished = contentStatus === 'published';
	const isScheduled = contentStatus === 'scheduled';
	const isDraft = contentStatus === 'draft';

	const [ openOptions, setopenOptions ] = useState<boolean>(false);
	const [ selectedTab, setSelectedTab ] = useState<string>('Details');

	/**
   * Open the move to slider drawer
   * @param event Mouse event
   */
	const handleOpenMoveToSlider = (
		event: React.MouseEvent<HTMLElement>
	): void =>
	{
		event.stopPropagation();
		setMoveTo(true);
	};

	const handleOpenPlaylistToSlider = (
		event: React.MouseEvent<HTMLElement>
	): void =>
	{
		event.stopPropagation();
		setAddPlaylist(true);
	};
	const handleClosePlaylistToSlider = (): void =>
	{
		setAddPlaylist(false);
	};

	const handleCloseMoveToSlider = (): void =>
	{
		setMoveTo(false);
	};

	// Type assertion for Drawer's onClose callback
	const typedHandleCloseMoveToSlider = handleCloseMoveToSlider as () => void;

	const handleCloseEditSlider = (): void =>
	{
		setEditContent(null);
	};
	// Type assertion for Drawer's onClose callback
	const typedHandleCloseEditSlider = handleCloseEditSlider as () => void;

	const handleEditContent = (event: React.MouseEvent<HTMLElement>): void =>
	{
		event.stopPropagation();

		if (localContentData && Object.keys(localContentData).length > 0)
		{
			// Transform data based on content type
			if (type === CONTENT_TYPES.VIDEOS)
			{
				const transformedData = transformVideoDataForSlider(localContentData);

				if (transformedData && Object.keys(transformedData).length > 0)
				{
					setEditContent(transformedData);
				}
			}
			else if (type === CONTENT_TYPES.IMAGES)
			{
				const transformedData = transformImageDataForSlider(localContentData);

				if (transformedData && Object.keys(transformedData).length > 0)
				{
					setEditContent(transformedData);
				}
			}
			else if (type === CONTENT_TYPES.DOCUMENTS)
			{
				const transformedData = transformDocumentDataForSlider(localContentData);

				if (transformedData && Object.keys(transformedData).length > 0)
				{
					setEditContent(transformedData);
				}
			}
			else if (type === CONTENT_TYPES.PODCASTS)
			{
				const transformedData = transformPodcastDataForSlider(localContentData);

				if (transformedData && Object.keys(transformedData).length > 0)
				{
					setEditContent(transformedData);
				}
			}
			else if (type === CONTENT_TYPES.ARTICLES)
			{
				navigate(`/businessSettings/content/editArticle/${localContentData?._id}`);
			}
			else if (type === CONTENT_TYPES.PLAYLISTS)
			{
				// For playlists, we can directly use the data as is or transform if needed
				setEditContent(localContentData);
			}
			else
			{
				// For other content types, pass original data (future enhancement)
				setEditContent(localContentData);
			}
		}
	};

	// const handleDeleteCategory = (event: React.MouseEvent<HTMLElement>): void =>
	// {
	// 	event.stopPropagation();
	// 	setCategoryDelete(true);
	// };

	// const handleOpenOptions = (event: React.MouseEvent<HTMLElement>): void =>
	// {
	// 	event.stopPropagation();
	// 	setopenOptions(true);
	// };

	// Handles closing the options drawer
	// Matches Material-UI Drawer's onClose callback signature
	const handleCloseOptions = (): void =>
	{
		setopenOptions(false);
		setSelectedTab('Details');
	};
	// Type assertion for Drawer's onClose callback
	const typedHandleCloseOptions = handleCloseOptions as () => void;

	// const handleClickmenu = (_e: React.MouseEvent<HTMLElement>): void =>
	// {
	// 	_e.stopPropagation();
	// 	setAnchorElShare(_e.currentTarget);
	// 	setAnchorElMenu(null);
	// };

	const location = window.location.pathname;

	const isCardHovered = (): boolean =>
	{
		return (
			hoveredCardId !== undefined &&
			hoveredCardId.length > 0 &&
			card !== undefined &&
			hoveredCardId.includes(card.id)
		);
	};

	/**
   * Get the background color based on content status
   * @param status The content status
   * @returns The background color for the status indicator
   */
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const getStatusColor = (status?: string): string =>
	{
		const statusValue = status || CONTENT_STATUS.DRAFT;

		switch (statusValue)
		{
			case CONTENT_STATUS.DRAFT:
				return '#FFA500'; // Orange for drafts
			case CONTENT_STATUS.PUBLISHED:
				return '#4CAF50'; // Green for published
			case CONTENT_STATUS.ARCHIVED:
				return '#9E9E9E'; // Grey for archived
			case CONTENT_STATUS.SCHEDULED:
				return '#2196F3'; // Blue for scheduled
			default:
				return '#FFA500'; // Default to draft color
		}
	};
	const handleUserView = (): void =>
	{
		// const path = location.includes('/subCategories')
		// 	? '/resource/subCategories/view'
		// 	: '/resource/view';

		const isNetworkPath = window.location.pathname.includes('/resource/network');
		const path = window.location.pathname.includes('/subCategories')
			? '/resource/subCategories/view'
			: isNetworkPath
				? `/resource/network/view/${contentData?.companyId}`
				: '/resource/view';

		if (section === CONTENT_SECTIONS.IMAGES)
		{
			trackImageView(contentData?._id);
		}
		else if (section === CONTENT_SECTIONS.VIDEOS)
		{
			trackVideoView(contentData?._id);
		}
		else if (section === CONTENT_SECTIONS.PODCASTS)
		{
			updatePodcastEngagement(contentData?._id, 'views');
		}
		else if (section === CONTENT_SECTIONS.DOCUMENTS)
		{
			trackDocumentView(contentData?._id);
		}
		else if (section === CONTENT_SECTIONS.ARTICLES)
		{
			trackArticleView(contentData?._id);
		}
		else if (section === CONTENT_SECTIONS.PLAYLISTS)
		{
			trackPlaylistView(contentData?._id);
		}

		const navigatePath = contentData?._id
			? `${path}/${section}/${contentData?._id}${section !== CONTENT_SECTIONS.PLAYLISTS ? `?categoryId=${categoryId}` : ''}`
			: `${path}/${section}`;

		navigate(navigatePath, { state: { watchedContentData: contentData?.watchData } });
	};
	const cardRef = useRef<HTMLDivElement | null>(null);
	const handleImagePreview = (): void =>
	{
		console.log('contentData****', contentData);
		// Get the current status from search params to preserve it
		const searchParams = new URLSearchParams(window.location.search);
		const currentStatus = searchParams.get('status');
		const statusParam = currentStatus ? `&status=${currentStatus}` : '';

		if (type === 'Articles')
		{
			navigate(`/businessSettings/content/article-view?id=${contentData?._id}${statusParam}`);
		}
		else if (type === 'Documents')
		{
			navigate(`/businessSettings/content/document-view?id=${contentData?._id}${statusParam}`, { state: { contentData } });
		}
		else if (type === 'Podcasts')
		{
			navigate(`/businessSettings/content/podcast-view?id=${contentData?._id}${statusParam}`);
		}
		else if (type === 'Playlists')
		{
			navigate(`/businessSettings/content/playlist-view?id=${contentData?._id}${statusParam}`);
		}
		else if (type === 'Videos')
		{
			navigate(`/businessSettings/content/video-view?id=${contentData?._id}${statusParam}`);
		}
		else if (type === 'Images')
		{
			navigate(`/businessSettings/content/image-view?id=${contentData?._id}${statusParam}`, { state: { contentData } });
		}
		else if (handleClick)
		{
			handleClick();
		}
	};

	// const handleClickCheckbox = (e: React.ChangeEvent<HTMLInputElement>): void =>
	// {
	// 	e.stopPropagation();
	// 	setAnchorEl(null);
	// 	handleCheckboxChange && handleCheckboxChange(contentData?._id, e.target.checked);
	// };

	// console.log('contentData****', contentData);
	const contentPath = {
		articles  : 'article-view',
		documents : 'document-view',
		podcasts  : 'podcast-view',
		playlists : 'playlist-view',
		videos    : 'video-view',
		images    : 'image-view'
	};

	const handleCopyLink = (e: React.MouseEvent<HTMLElement>): void =>
	{
		e.stopPropagation();

		const baseUrl = window.location.origin;
		const contentType = type === 'Videos'
			? 'videos'
			: type === 'Documents'
				? 'documents'
				: type === 'Images'
					? 'images'
					: type === 'Podcasts'
						? 'podcasts'
						: type === 'Articles'
							? 'articles'
							: type === 'Playlists'
								? 'playlists'
								: 'content';

		// Use _id for all content types since we're using contentData._id consistently
		const itemId = contentData?._id;

		// Use the memoized categoryId that's already defined in the component
		const link = `${baseUrl}/resource/view/${contentType}/${itemId}?categoryId=${categoryId}`;

		if (link)
		{
			navigator.clipboard.writeText(link)
				.then(() =>
				{
					toast.success('Link copied to clipboard!');
					console.log('Link copied to clipboard:', link);
				})
				.catch((error) =>
				{
					console.error('Failed to copy link:', error);
					toast.error('Failed to copy link to clipboard');
				});
		}
	};

	const handleAdminView = (): void =>
	{
		const searchParams = new URLSearchParams(window.location.search);
		const currentStatus = searchParams.get('status');
		const statusParam = currentStatus ? `&status=${currentStatus}` : '';

		if (!contentData?._id)
		{
			return;
		}

		if (contentPath[section])
		{
			navigate(`/businessSettings/content/${contentPath[section]}?id=${contentData._id}${statusParam}`);
		}
	};

	return (
		<>
			<Grow in timeout={400}>
				<Box
					ref={cardRef}
					bgcolor='#fff'
					borderRadius='13px'
					border='1px solid #D5D5D5'
					flex='0 0 260px'
					width={GridView ? '100%' : 270}
					className={`content-card ${disableInteractions ? 'disabled' : ''} ${contentStatus === 'unpublished' ? 'uncategorized' : ''} ${type === CONTENT_TYPES.PLAYLISTS ? 'playlist' : ''} ${isChecked ? 'checked' : ''} ${moveTo ? 'moving' : ''} ${editContent && Object.keys(editContent).length > 0 ? 'editing' : ''} ${!showPopover ? 'no-edit' : ''}`}
					display='flex'
					flexDirection='column'
					p='var(--pixel8)'
					onClick={() => (isAdminView ? handleAdminView() : handleUserView())}
				>
					{/* {type === CONTENT_TYPES.PLAYLISTS && (
						<Box
							position={'absolute'}
							border={'8px solid #0000001A'}
							top={'3px'}
							left={'21px'}
							width={'85%'}
							sx={{
								borderRadius : '10px 10px 0px 0px'
							}}
						/>
					)} */}

					{/* EditContent with CSS hover */}
					{isAdminView && !disableInteractions && (
						<Box
							className='edit-button'
							onClick={(e) => { e.stopPropagation(); }}
						>
							<EditContent
								handlePreview={handleImagePreview}
								ContentCategoryType={false}
								contentStatus={contentStatus}
								type={type}
								contentData={contentData}
								setCategoryData={() => {}}
								handleEditContent={handleEditContent}
								handlemOpenplaylisttoSlider={handleOpenPlaylistToSlider}
								handlemOpenMovetoSlider={handleOpenMoveToSlider}
								onDeleteSuccess={() => {}}
								fromType={'content'}
								handleCopyLink={handleCopyLink}
							/>
						</Box>
					)}

					{/* ThumbnailView with CSS hover effects */}
					<Box className='thumbnail-container'>
						<ThumbnailView
							type={type}
							contentData={contentData}
							section={section}
							fileUrl={fileUrl}
							watermarkTxt={watermarkTxt}
							isAdminView={isAdminView}
							from={from}
							contentStatus={contentStatus}
						/>
					</Box>
					{/* {showPath === true && ( */}
					<Typography
						variant='inherit'
						fontSize={10}
						color='#606162'
						py={1}
						mt={0.5}
						sx={{
							overflow     : 'hidden',
							textOverflow : 'ellipsis',
							whiteSpace   : 'nowrap'
						}}
					>
						{categoryData?.breadcrumb?.path}
					</Typography>
					{/* )} */}
					<Stack
						direction='row'
						pt={showPath ? 1 : 0}
						spacing={0.5}
						alignItems='center'
					>
						<Grid container>
							<Grid item xs overflow={'hidden'}>
								<Stack
									direction='row'
									spacing={0.5}
									alignItems='center'
									pb={1}
								>
									<Box>
										<ProfilePic
											imagePath={`${createdBy?.userId}.jpeg`}
											alt='creator profile'
											className='brdrRadius50'
											from='selfProfile'
											style={{
												width  : '20px',
												height : '20px'
											}}
										/>
									</Box>
									<Typography
										variant='caption'
										sx={{
											width        : 'var(--percent100)',
											overflow     : 'hidden',
											textOverflow : 'ellipsis',
											whiteSpace   : 'nowrap'
										}}
									>
										{createdByName}
									</Typography>
								</Stack>
							</Grid>
						</Grid>
					</Stack>
					<Typography
						variant='subtitle2'
						textTransform={'capitalize'}
						color='#283C50'
						fontWeight={'var(--font500)'}
						sx={{
							overflow     : 'hidden',
							whiteSpace   : 'nowrap',
							textOverflow : 'ellipsis'
						}}
					>
						{fileTitle}
					</Typography>
					{/* Popper and Menu components removed - now handled by CSS hover effects */}
					{/* <Popper
						open={open && hovered}
						anchorEl={anchorEl}
						onClick={handleClick}
						disablePortal
						container={document.getElementById('auto-scrollId')}
						placement={placement}
						modifiers={[
							{
								name    : 'preventOverflow',
								options : { boundary: 'clippingParents', padding: 8 }
							},
							{
								name    : 'flip',
								options : {
									fallbackPlacements : [ 'left', 'right' ]
								}
							},
							{
								name    : 'offset',
								options : { offset: [ 0, 10 ] }
							},
							{
								name    : 'computeStyles',
								options : {
									adaptive        : true,
									gpuAcceleration : true
								}
							}
						]}
						sx={{
							zIndex              : 11,
							width               : cardWidth,
							backgroundImage     : `url('${fileUrl}')`,
							backgroundSize      : 'cover',
							backgroundPosition  : 'center',
							backgroundRepeat    : 'no-repeat',
							backgroundBlendMode : 'overlay',
							bgcolor             : 'rgba(0, 0, 0, 0.8)',
							color               : 'white',
							p                   : 2,
							borderRadius        : 2,
							boxShadow           : '0px 2px 4px rgba(0, 0, 0, 0.2)',
							transform           : `translate3d(${translateX}px, ${translateY}px, 0px) !important`,
							'&::before'         : categories === 'Uncategorized'
								? {
									content      : '""',
									position     : 'absolute',
									top          : 0,
									left         : 0,
									width        : '100%',
									height       : '100%',
									filter       : 'blur(20px)',
									zIndex       : -1,
									borderRadius : 2,
									background   : 'rgba(255, 255, 255, 0.3)'
								}
								: {}
						}}
					>
						<PopoverContentView
							type={type}
							contentData={localContentData}
							section={section}
							handleCheckboxChange={handleClickCheckbox}
							handleEditContent={handleEditContent}
							handlemOpenMovetoSlider={handleOpenMoveToSlider}
							setContentView={setContentView}
							ContentView={ContentView}
							handleOpenOptions={handleOpenOptions}
							card={card}
							hoveredCardId={hoveredCardId}
							handlemOpenplaylisttoSlider={handleOpenPlaylistToSlider}
							handleImagePreview={handleImagePreview}
							fromType='content'
						/>
					</Popper> */}
					{/* <Menu
						id='basic-menu'
						anchorEl={anchorElMenu}
						open={Boolean(anchorElMenu) && hovered}
						onClose={(e:any) => { e?.stopPropagation(); setAnchorElMenu(null); }}
						MenuListProps={{
							'aria-labelledby' : 'basic-button'
						}}
					>
						<MenuItem
							onClick={(e: React.MouseEvent<HTMLElement>) =>
							{
								e.stopPropagation();
								setAnchorElMenu(null);
							}}
						>
							{language?.download ?? 'Download'}
						</MenuItem>
						<MenuItem onClick={handleCopyLink}>
							Copy Link
						</MenuItem>
						<MenuItem onClick={handleClickmenu}>
							{language?.share ?? 'Share'}
						</MenuItem>
					</Menu> */}
				</Box>
			</Grow>
			<Drawer
				anchor='right'
				open={moveTo}
				onClose={typedHandleCloseMoveToSlider}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '40%',
							lg : '30%'
						}
					}
				}}
			>
				<MoveToSlider
					onClose={typedHandleCloseMoveToSlider}
					contentId={localContentData?._id}
					contentType={type}
					contentName={(() =>
					{
						switch (type)
						{
							case CONTENT_TYPES.VIDEOS:
								return localContentData?.videos?.[0]?.title || localContentData?.title || 'Untitled Video';
							case CONTENT_TYPES.IMAGES:
								return localContentData?.files?.[0]?.title || localContentData?.title || 'Untitled Image';
							case CONTENT_TYPES.DOCUMENTS:
								return localContentData?.files?.[0]?.title || localContentData?.title || 'Untitled Document';
							case CONTENT_TYPES.PLAYLISTS:
								return localContentData?.name || 'Untitled Playlist';
							case CONTENT_TYPES.PODCASTS:
								return localContentData?.title || localContentData?.files?.[0]?.title || localContentData?.name || 'Untitled Audio';
							default:
								return localContentData?.title || localContentData?.name || 'Untitled Content';
						}
					})()}
					// Pass category data for source resolution (now handled in MoveToSlider)
					categoryData={categoryData}
					sourceCategoryName={categoryData?.name || 'Current Category'}
					onMoveSuccess={(targetCategoryId, targetCategoryName) =>
					{
						// Handle successful move - could refresh data or show notification
						console.log(`Content moved to ${targetCategoryName}`);
						// Call parent refresh callback if provided
						if (props.onMoveSuccess)
						{
							props.onMoveSuccess();
						}
					}}
					onMoveError={(error) =>
					{
						console.error('Move failed:', error);
					}}
				/>
			</Drawer>
			<Drawer
				anchor='right'
				open={editContent && Object.keys(editContent).length > 0}
				onClose={typedHandleCloseEditSlider}
				sx={{ zIndex: '1015 !important' }}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '40%',
							lg : '35%'
						}
					}
				}}
			>
				{type === CONTENT_TYPES.VIDEOS && (
					<VideoDetailsSlider
						setOpen={() => setEditContent(null)}
						selectedTab={state.data.selectedTab}
						setSelectedTab={(tab) => updateData({ selectedTab: tab })}
						articleCreate='video'
						videoData={editContent || undefined}
						onSave={handleContentUpdates}
					/>
				)}
				{type === CONTENT_TYPES.IMAGES && (
					<ImageDetailsSlider
						setOpen={() => setEditContent(null)}
						selectedTab={state.data.selectedTab}
						setSelectedTab={(tab) => updateData({ selectedTab: tab })}
						articleCreate='image'
						imageData={editContent || undefined}
						onSave={handleContentUpdates}
					/>
				)}
				{type === CONTENT_TYPES.DOCUMENTS && (
					<DocumentDetailsSlider
						setOpen={() => setEditContent(null)}
						selectedTab={state.data.selectedTab}
						setSelectedTab={(tab) => updateData({ selectedTab: tab })}
						articleCreate='document'
						documentData={editContent || undefined}
						onSave={handleContentUpdates}
					/>
				)}
				{type === CONTENT_TYPES.PODCASTS && (
					<PodcastDetailsSlider
						setOpen={() => setEditContent(null)}
						selectedTab={state.data.selectedTab}
						setSelectedTab={(tab) => updateData({ selectedTab: tab })}
						articleCreate='podcast'
						podcastData={editContent || undefined}
						onSave={handleContentUpdates}
					/>
				)}
				{type === CONTENT_TYPES.PLAYLISTS && (
					<CategorySlider
						categoryType='playlist'
						setOpen={() => setEditContent(null)}
						selectedTab={state.data.selectedTab}
						// setSelectedTab={(tab) => updateData({ selectedTab: tab })}
						playlistData={editContent}
						onSave={handleContentUpdates}
						sliderEdit
					/>
				)}
			</Drawer>
			<Drawer
				anchor='right'
				open={openOptions}
				onClose={typedHandleCloseOptions}
				sx={{ zIndex: '999' }}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '40%',
							lg : '30%'
						}
					}
				}}
			>
				<DetailsOptionSlider
					setOpen={setopenOptions}
					selectedTab={selectedTab}
					setSelectedTab={setSelectedTab}
				/>
			</Drawer>
			<Drawer
				anchor='right'
				open={addPlaylist}
				onClose={handleClosePlaylistToSlider}
				sx={{ zIndex: '1015 !important' }}
				PaperProps={{
					sx : {
						width : {
							xs : 'var(--percent100)',
							sm : '70%',
							md : '40%',
							lg : '35%'
						}
					}
				}}
			>
				<CategorySlider categoryType='playlist' />
			</Drawer>
			{/* {openShare && (
				<ShareDialog
					open={openShare}
					onClose={() => setAnchorElShare(null)}
					title={language?.share ?? 'Share'}
					subtitle={language?.sharecontent ?? 'Share content'}
					type='content'
				/>
			)} */}
		</>
	);
};

export default ContentCards;
